import "../style.css";
import React, { useState, useContext, useEffect } from "react";
import Graph from "../Graph/Graph";
import Tab from "../Tab/Tab";
import { useLocation } from "react-router-dom";
let formatDate = (date) => {
  let year = new Date(date).getFullYear().toString().slice(2, 4);
  let month = (new Date(date).getMonth() + 1).toString();
  let day = new Date(date).getDate().toString();
  let newDate = `${month.length < 2 ? `0${month}` : month}/${day.length < 2 ? `0${day}` : day
    }/${year}`;

  return newDate;
};


const filterByBook = (bookName, items) => {
  let filteredItems = items.filter((item) => item.bookName.toLowerCase().trim() === bookName.toLowerCase().trim())
  return filteredItems
}

const reduceSet = (arr) => {
  const normalizedArr = arr.map(str => str.trim().toLowerCase());

  // Use a Set to track seen books, but iterate **from right to left** to keep last occurrence
  const seen = new Set();
  const reducedArr = [];

  for (let i = normalizedArr.length - 1; i >= 0; i--) {
    if (!seen.has(normalizedArr[i])) {
      seen.add(normalizedArr[i]);
      reducedArr.unshift(arr[i]); // Keep original formatting of last occurrence
    }
  }
  return reducedArr
}



export default function Graphs({ userDetails, setLastWPM }) {
  const location = useLocation()
  const [isStudentDetailShow, setIsStudentDetailsShow] = useState(location.pathname == "/StudentDetails")
  const [assesmentRestData, setAssementResData] = useState(null);
  const [lastAsses, setLastAsses] = useState(0)
  const [lastPUSHUP, setLastPUSHUP] = useState(0)
  const [lastTF, setLastTF] = useState(0)
  const [booksList, setBooksList] = useState(userDetails.TR.length > 0 ? reduceSet(userDetails.TR.map(item => item.bookName)) : [])
  const [bookName, setBookName] = useState(booksList[booksList.length - 1]);
  const [counter, setCounter] = useState(0)
  //build the graph details
  function buildData(objName) {
    if (!objName.length) return;
    //objName contails the dots on the graph (y=as value, x=as date)
    //debugger
    //const oName = focusData[]
    let xValues = [];
    let yValues = [];
    let graphData = {};

    //initial day - the first day that we have in our dots
    let initialDay = new Date(formatDate(objName[0].date));
    //till today
    let st = new Date();
    let daysGap = st - initialDay;
    //gets the days list on the x-values
    let days = Math.floor(daysGap / (1000 * 3600 * 24)) + 1;

    // create empty graphData

    for (let index = 0; index < days; index++) {
      let tempDateRes = new Date(initialDay);
      tempDateRes = new Date(tempDateRes.setDate(initialDay.getDate() + index));
      graphData[formatDate(tempDateRes)] = "";
      xValues[index] = formatDate(tempDateRes);
    }
    // load input into graph
    //graphData will be an array that contains places for all dates on graph and has values only where we have value
    objName.map((res) => {
      return res.result ? res.result.WPM ? (graphData[formatDate(res.date)] = res.result) : (graphData[formatDate(res.date)] = null) : (graphData[formatDate(res.date)] = Math.floor(res.value));
    });

    let c = 0;
    let lastVal = 0;
    let STDArr = [];
    let CMPArr = [];
    Object.keys(graphData).forEach((key) => {
      if (!graphData[key] || graphData[key] < 1) {
        yValues[c] = null;
        STDArr[c] = null;
        CMPArr[c] = null;
      } else {
        if (graphData[key].WPM) {
          yValues[c] = Number(graphData[key].WPM);
          STDArr[c] = graphData[key].STD;
          CMPArr[c] = graphData[key].CMP;
        } else {
          yValues[c] = graphData[key];
        }
        lastVal = graphData[key];
      }
      c++;
    });

    // setAssementResData()
    let output = { xValues: xValues, yValues: yValues };
    return { output, STDArr, CMPArr };
  }
  //
  const ass = userDetails.assessments.length ? userDetails.assessments[userDetails?.assessments?.length - 1]?.result.WPM : 0;
  const read = userDetails.TR.length ? userDetails.TR[userDetails?.TR?.length - 1]?.value : 0;
  const focus = userDetails.TF.length ? Math.floor(userDetails?.TF[userDetails.TF.length - 1]?.value) : 0;
  // const ass = fakeData.AssessmentData[fakeData.AssessmentData.length - 1].Value,
  //     read = fakeData.readingData[fakeData.readingData.length - 1].Value,
  //     focus = fakeData.focusData[fakeData.focusData.length - 1].Value;
  const tabParams = { ass: ass, read: read, focus: focus };

  const tabs = [
    {
      tabName: "WEEKLY MEASUREMENT",
      last: `${lastAsses}`,
      dataArrayName: userDetails.assessments.length ? userDetails.assessments : [],
      unit: "WPM",
    },
    {
      tabName: "PUSHUP",
      last: `${lastPUSHUP}`,
      dataArrayName: userDetails.TR.length ? filterByBook(bookName, userDetails.TR) : [],
      unit: "LPM",
    },
    {
      tabName: "NEAR POINT",
      last: `${lastTF}`,
      dataArrayName: userDetails.TF.length ? userDetails.TF : [],
      unit: "CM",
    },
  ];
  useEffect(() => {
    // setTimeout(() => {
    setCounter(f => f + 1)
    // }, 1000)
  }, [bookName]);
  const handleBookChange = (e) => {
    setBookName(e.target.value)
  }
  useEffect(() => {
    setLastWPM(lastAsses)
  }, [lastAsses, lastTF, lastPUSHUP])
  return (
    <>
      {isStudentDetailShow && <div className="selectBook" >
        <select value={bookName} onChange={handleBookChange}>
          {booksList.map((book, index) => (
            <option key={index} value={book}>
              {book}
            </option>
          ))}
        </select>
      </div>}
      {tabs.map((tab, index) => {
        return (

          <div className="Graph">
            <div className="Tabs">
              <Tab
                tabName={tab.tabName}
                last={tab.last}
                tabUnit={tab.unit}
                tabMS={tab.tabMS}
                dataArrayName={tab.dataArrayName}
                selectedTab={tabs[index].tabName}
                tabIndex={index}


              />
            </div>
            <div className="DashGraph   back-purple right">
              {tab.dataArrayName.length ?
                <Graph
                  graphName={tab.tabName}
                  allData={buildData(tab.dataArrayName)}
                  tabUnit={tabs[index].unit}
                  setLastTF={setLastTF}
                  setLastAsses={setLastAsses}
                  setLastPUSHUP={setLastPUSHUP}
                  counter={counter}
                />
                :
                <div className="no-data-message">
                  No data available for this graph.
                </div>

              }
            </div>
          </div>)
      })
      }
    </>
  );
}
